import { HttpClient, HttpHeaders, HttpParams, HttpRequest,HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { RuleDto } from 'src/app/shared/models/rule';

@Injectable({
  providedIn: 'root',
})

export class LeadsService {
  private webMasterId: string | null = null;

  constructor(private http: HttpClient) { }

 

  isTokenValid(keycloackToken: string): Observable<boolean> {
    return this.http.get<any>(
      environment.BACK_LEADS_SERVICE + environment.GET_COUNT_ALL_LEADS_BY_STATUS_PATH,
      {
        headers: { Authorization: "Bearer "+ keycloackToken },
        observe: 'response' 
      }
    ).pipe(
      map((response: HttpResponse<any>) => {
        return response.status === 200;
      }),
      catchError(error => {
        if (error.status === 406) {
          return of(false); 
        } else {
          return of(null);
        }
      })
    );
  }

  getToken(username: string, password: string): Observable<any> {
    const authHeader = 'Basic ' + btoa(`${username}:${password}`);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', // Assuming your server expects JSON
      'Authorization': authHeader
    });

    const body = {}; // Add any required fields in the request body
    return this.http.post<any>(
      `${environment.BACK_LEADS_SERVICE}/auth/get-token`,
      body,
      { headers: headers }
    );
  }
  

  getLeads(keycloakToken: string, filterParams: any): Observable<any> {
    const webMasterId = localStorage.getItem('webMasterId');
    let updatedFilterParams = { ...filterParams };
    if (webMasterId) {
      updatedFilterParams = { ...updatedFilterParams, webmaster: webMasterId };
    }
  
    return this.http.get(environment.BACK_LEADS_SERVICE + environment.GET_LEADS_PATH, {
      headers: { Authorization: keycloakToken },
      params: updatedFilterParams,
    }).pipe(
      map((res: Response) => res)
    );
  }
  

  getProducts(keycloackToken, referenceNumber , isLeadGenerator) {
    return this.http
      .get(environment.BACK_LEADS_SERVICE + environment.GET_PRODUCTS+`?referenceNumber=${referenceNumber}&&isLeadGenerator=${isLeadGenerator}`, {
        headers: { Authorization: keycloackToken },
      })
      .pipe(map((res: Response) => res));
  }

  getCountAllLeads(keycloakToken: string , webMasterId : string): Observable<any> {
    let params = {};
    if (webMasterId) {
      params = { webmaster: webMasterId };
    }
  
    return this.http.get(environment.BACK_LEADS_SERVICE + environment.GET_COUNT_ALL_LEADS_BY_STATUS_PATH, {
      headers: { Authorization: keycloakToken },
      params: params,
    }).pipe(
      map((res: Response) => res)
    );
  }


  getCountLeads(keycloakToken: string, filterParams: any): Observable<any> {
    const webMasterId = localStorage.getItem('webMasterId');
    let params = { ...filterParams };
  
    if (webMasterId) {
      params['webmaster'] = webMasterId;
    }
  
    return this.http.get(environment.BACK_LEADS_SERVICE + environment.GET_LEADS_COUNT_PATH, {
      headers: { Authorization: keycloakToken },
      params: params,
    }).pipe(
      map((res: any) => res)
    );
  }
  


  getSkus(keycloakToken: string ): Observable<any> {
    let params = {};
    const webMasterId = localStorage.getItem('webMasterId');
    if (webMasterId) {
      params = { webmaster: webMasterId };
    }
  
    return this.http.get(environment.BACK_LEADS_SERVICE + environment.GET_SKUS_PATH, {
      headers: { Authorization: keycloakToken },
      params: params,
    }).pipe(
      map((res: Response) => res)
    );
  }


  getSkusByCompanies(keycloackToken,companyIds: number[]) {
    let url = environment.BACK_LEADS_SERVICE + environment.GET_SKUS_BY_COMPANIES_PATH;
    if (companyIds !== null) {
      url += `?companyIds=${companyIds.join(',')}`;
    } else {
      url += `?companyIds=`;
    }
    return this.http.get(url, {
      headers: { Authorization: keycloackToken },
    })
    .pipe(map((res: Response) => res));
  }

  getSkusByWebMasters(keycloakToken: string, webMaster: string[])  {
    let url = environment.BACK_LEADS_SERVICE + environment.GET_SKUS_BY_WEBMASTERS_PATH;
    if (webMaster !== null) {
      url += `?webMaster=${webMaster.join(',')}`;
    } else {
      url += `?webMaster=`;
    }
    return this.http.get(url, {
      headers: { Authorization: 'Bearer ' + keycloakToken },
    })
    .pipe(map((res: any) => res));
  }


  uploadLeads(file: File,keycloackToken) {
    const data: FormData = new FormData();
    data.append('file', file);
    console.log('uploading file in progress');
    return this.http
      .post(environment.BACK_LEADS_SERVICE + environment.uploadedFile,data, {
        headers: { Authorization: keycloackToken },
      })
      .pipe(map((res: Response) => res));
    }

  exportLeadsToExcel(keycloackToken: string, referenceNumbers: string[]) {
    const requestBody = JSON.stringify(referenceNumbers);
    return this.http.post(environment.BACK_LEADS_SERVICE + environment.EXPORT_CSV, requestBody, {
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': keycloackToken 
      },
      
      responseType: 'blob'
    }).pipe(
      map((response: Blob) => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'leads.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
    );
  }

  updateLeadsByExcel(file: File,keycloackToken:string) {
    const data: FormData = new FormData();
    data.append('file', file);
    console.log('Updating file in progress');
    return this.http
      .put(environment.BACK_LEADS_SERVICE + environment.updateLeadsByExcel,data, {
        headers: { Authorization: keycloackToken },
      })
      .pipe(map((res: Response) => res));
    }
  updateLeadsBySpreadsheet(data:any,keycloackToken:string) {
      console.log('Updating file in progress');
      return this.http
        .put(environment.BACK_LEADS_SERVICE + environment.updateLeadsBySpreadsheet + '?SheetName=' + data.sheetName + '&SheetLink=' + data.sheetLink,null, {
          headers: { Authorization: keycloackToken },
        })
        .pipe(map((res: Response) => res));
  }
  uploadLeadsBySpreadsheet(data:any,keycloackToken:string) {
    console.log('uploading sheet in progress');
    return this.http
      .post(environment.BACK_LEADS_SERVICE + environment.updateLeadsBySpreadsheet + '?SheetName=' + data.sheetName + '&SheetLink=' + data.sheetLink,null, {
        headers: { Authorization: keycloackToken },
      })
      .pipe(map((res: Response) => res));
}


getreferenceNumber(keycloakToken: string): Observable<any> {
  const webMasterId = localStorage.getItem('webMasterId');
  let params = {};

  if (webMasterId) {
    params = { webmaster: webMasterId };
  }

  return this.http.get(environment.BACK_LEADS_SERVICE + environment.GET_REFERENCE_NUMBER, {
    headers: { Authorization: keycloakToken },
    params: params,
  }).pipe(
    map((res: Response) => res)
  );
}


  getLeadsReports(filterParams: any, keycloackToken: string) {
    return this.http.post(environment.BACK_LEADS_SERVICE + '/Reports', filterParams, {
      headers: { Authorization: 'Bearer ' + keycloackToken }
    }).pipe(map((res: Response) => res));
  }
  
  getCountries(keycloakToken: string) {
    let url = environment.BACK_LEADS_SERVICE +'/Reports/countries';
    this.webMasterId = localStorage.getItem('webMasterId');
    if (this.webMasterId) {
      url += '?webmaster=' + this.webMasterId;
    }
    return this.http.get(url, {
      headers: { Authorization: 'Bearer ' + keycloakToken }
    }).pipe(
      map((res: Response) => res)
    );
  }


  getCountriesByCompanies(keycloackToken,companyIds: number[]) {
    let url = environment.BACK_LEADS_SERVICE + environment.GET_COUNTRIES_BY_COMPANIES_PATH;
    if (companyIds !== null) {
      url += `?companyIds=${companyIds.join(',')}`;
    } else {
      url += `?companyIds=`;
    }
    return this.http.get(url, {
      headers: { Authorization:'Bearer ' + keycloackToken },
    })
    .pipe(map((res: Response) => res));
  }

  getCountriesByWebMasters(keycloakToken ,webMaster: string[]){
    let url = environment.BACK_LEADS_SERVICE + environment.GET_COUNTRIES_BY_WEBMASTERS_PATH;
    if (webMaster !== null) {
      url += `?webMaster=${webMaster.join(',')}`;
    } else {
      url += `?webMaster=`;
    }
    return this.http.get(url, {
      headers: { Authorization: 'Bearer ' + keycloakToken },
    })
    .pipe(map((res: any) => res));
  }

  getCitiesByWebMasters(keycloakToken: string, webMaster: string[]) {
    let url = environment.BACK_LEADS_SERVICE + environment.GET_CITIES_BY_WEBMASTERS_PATH;
    if (webMaster !== null) {
      url += `?webMaster=${webMaster.join(',')}`;
    } else {
      url += `?webMaster=`;
    }
    return this.http.get(url, {
      headers: { Authorization: 'Bearer ' + keycloakToken },
    })
    .pipe(map((res: any) => res));
  }
  
  getProvincesByWebMasters(keycloakToken: string, webMaster: string[]) {
    let url = environment.BACK_LEADS_SERVICE + environment.GET_PROVINCES_BY_WEBMASTERS_PATH;
    if (webMaster !== null) {
      url += `?webMaster=${webMaster.join(',')}`;
    } else {
      url += `?webMaster=`;
    }
    return this.http.get(url, {
      headers: { Authorization: 'Bearer ' + keycloakToken },
    })
    .pipe(map((res: any) => res));
  }
  

  getYouCanShop(keycloackToken,code) {
    return this.http
      .get("http://localhost:8083/api/generator/youcan/auth?code="+code, {
        headers: { Authorization: "Bearer "+keycloackToken },
      })
      .pipe(map((res: Response) => res));
  }
  
  getCities(keycloakToken: string) {
    this.webMasterId = localStorage.getItem('webMasterId');
    let url = environment.BACK_LEADS_SERVICE + '/Reports/cities';
    if (this.webMasterId) {
      url += '?webmaster=' + this.webMasterId;
    }

    return this.http.get(url, {
      headers: { Authorization: 'Bearer ' + keycloakToken }
    }).pipe(
      map((res: Response) => res)
    );
  }
  getCitiesByCompanies(keycloackToken,companyIds: number[]) {
    let url = environment.BACK_LEADS_SERVICE + environment.GET_CITIES_BY_COMPANIES_PATH;
    if (companyIds !== null) {
      url += `?companyIds=${companyIds.join(',')}`;
    } else {
      url += `?companyIds=`;
    }
    return this.http.get(url, {
      headers: { Authorization:'Bearer ' + keycloackToken },
    })
    .pipe(map((res: Response) => res));
  }
 
  getProvinces(keycloakToken: string) {
    let url = environment.BACK_LEADS_SERVICE + '/Reports/provinces';
    this.webMasterId = localStorage.getItem('webMasterId');
    if (this.webMasterId) {
      url += '?webmaster=' + this.webMasterId;
    }
    return this.http.get(url, {
      headers: { Authorization: 'Bearer ' + keycloakToken }
    }).pipe(
      map((res: Response) => res)
    );
  }
  getProvincesByCompanies(keycloackToken,companyIds: number[]) {
    let url = environment.BACK_LEADS_SERVICE + environment.GET_PROVINCES_BY_COMPANIES_PATH;
    if (companyIds !== null) {
      url += `?companyIds=${companyIds.join(',')}`;
    } else {
      url += `?companyIds=`;
    }
    return this.http.get(url, {
      headers: { Authorization:'Bearer ' + keycloackToken },
    })
    .pipe(map((res: Response) => res));
  }
  searchLeads(keycloackToken,searchFilter, page, size) {
    console.log("search filter DTO ",searchFilter)
    let url = environment.BACK_LEADS_SERVICE + environment.GET_LEADS_BY_SEARCH_PATH;
    return this.http.post(url, searchFilter, {
      headers: { Authorization:'Bearer ' + keycloackToken },
      params: {
        page: page,
        size: size
      }
    });
  }
  searchLeadsCount(keycloackToken,searchFilter) {
    console.log("search filter DTO ",searchFilter)
    let url = environment.BACK_LEADS_SERVICE + environment.GET_LEADS_BY_SEARCH_PATH+"/findLeadsBySearchCount";
    return this.http.post(url, searchFilter, {
      headers: { Authorization:'Bearer ' + keycloackToken }
    });
  }
  createRule(keycloakToken: string, ruleDto: RuleDto): Observable<any> {
    let url = environment.BACK_LEADS_SERVICE + '/rule';

    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + keycloakToken,
      'Content-Type': 'application/json'
    });
    console.log('Body being sent to createRule:', JSON.stringify(ruleDto, null, 2));
    return this.http.post(url, ruleDto, { headers: headers });
  }

}
  
